import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CartComponentStore } from 'cart-data';
import { CartItemResultListComponent } from '../cart-item-result-list/cart-item-result-list.component';

@Component({
  selector: 'ideal-cart-item-results',
  imports: [CartItemResultListComponent],
  standalone: true,
  templateUrl: './cart-item-results.component.html',
  styleUrl: './cart-item-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartItemResultsComponent {
  private readonly _store = inject(CartComponentStore);
  private readonly _items = computed(() => this._store.cartItems());
  protected readonly ids = computed(() => this._items().map((item) => item.id));
}
